import { Box, Typography, Container, Button } from "@mui/material";
import ApplyNowModal from "../ApplyNowModal";
import React, { useState } from "react";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

export default function Hero() {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState("");

  const handleOpenModal = (jobName) => {
    setSelectedJob(jobName || "General Application");
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedJob(""); // Prevent stale values
  };

  return (
    <Box
      sx={{
        position: "relative",
        height: { xs: "320px", md: "450px" },
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "#fff",
      }}
    >
      <img
        src="https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzs5m5iUK3C2CdOwDf9aYccwSmuUQCDqwe4PRd1id7Y05M49wmf7MYqkOofJnKONavfzPUp8isa8JECnXlAATNm95OGbZW-k_8slD1kCImgL9ixoxy80tQKP5qRhjayKN2TNPVKbbkCDZQ=s1360-w1360-h1020-rw"
        alt="Careers Hero"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 1,
        }}
      />

      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: `${brandBlue}CC`,
          zIndex: 2,
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 3 }}>
        <Typography
          variant="h3"
          fontWeight={800}
          sx={{
            mb: 2,
            fontSize: { xs: "2rem", md: "3rem" },
            letterSpacing: "1px",
            textTransform: "uppercase",
          }}
        >
          Grow. Innovate. Succeed.
        </Typography>

        <Box
          sx={{
            width: "90px",
            height: "5px",
            background: brandRed,
            mx: "auto",
            borderRadius: 1,
            mb: 3,
          }}
        />

        <Typography
          variant="h6"
          sx={{
            maxWidth: "680px",
            mx: "auto",
            fontSize: { xs: "1rem", md: "1.25rem" },
            mb: 3,
          }}
        >
          Join a team that transforms engineering and makes a real global
          impact.
        </Typography>

        <Button
          variant="contained"
          sx={{
            background: brandRed,
            fontWeight: "bold",
            px: 4,
            py: 1.2,
            borderRadius: "50px",
          }}
          onClick={() => handleOpenModal("General Application")}
        >
          Apply Now
        </Button>

        <ApplyNowModal
          open={modalOpen}
          onClose={handleCloseModal}
          selectedJob={selectedJob}
        />
      </Container>
    </Box>
  );
}
